<template><section><h1>Transfer 穿梭框</h1>
<h2>基本用法</h2>
<p>data为需要传递的左右框的所有数据，类型为Array,里边的每一项都有一个唯一的key,作为唯一标识，disabled类型为Boolean,定义该项是否禁用</p>
<demo-block>
                    <div class="source" slot="source"><template>
  <nt-transfer :data="datatransfer" :targetKeys="targetKeys" @change="handleCHangeTranfer"></nt-transfer>
</template>



</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">nt-transfer</span> <span class="hljs-attr">:data</span>=<span class="hljs-string">"datatransfer"</span> <span class="hljs-attr">:targetKeys</span>=<span class="hljs-string">"targetKeys"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"handleCHangeTranfer"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-transfer</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data() {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">datatransfer</span>: [
        { <span class="hljs-attr">key</span>: <span class="hljs-string">"1"</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"Content 1"</span>, <span class="hljs-attr">disabled</span>: <span class="hljs-literal">false</span> },
        { <span class="hljs-attr">key</span>: <span class="hljs-string">"2"</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"Content 2"</span>, <span class="hljs-attr">disabled</span>: <span class="hljs-literal">true</span> },
        { <span class="hljs-attr">key</span>: <span class="hljs-string">"3"</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"Content 3"</span>, <span class="hljs-attr">disabled</span>: <span class="hljs-literal">false</span> }
      ],
      <span class="hljs-attr">targetKeys</span>: [<span class="hljs-string">"1"</span>, <span class="hljs-string">"2"</span>]
    };
  },
  <span class="hljs-attr">methods</span>: {
    handleCHangeTranfer(newT) {
      <span class="hljs-built_in">console</span>.log(newT);
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">data</td>
<td style="text-align:left">原始列表和目标列表的所有数据</td>
<td style="text-align:left">Array</td>
<td style="text-align:left">每一项需要有唯一的key值</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">targetKeys</td>
<td style="text-align:left">目标列表数据的key组成的Array</td>
<td style="text-align:left">Array</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">disabled</td>
<td style="text-align:left">该项是否禁用</td>
<td style="text-align:left">boolean</td>
<td style="text-align:left"><code v-pre>true</code> <code v-pre>false</code></td>
<td style="text-align:left"><code v-pre>false</code></td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">change</td>
<td style="text-align:left">点击穿梭按钮时触发的事件</td>
<td style="text-align:left">参数为一个数组，有两个原素，第一个元素为原始列表的数据Array,第二个元素为目标列表的数据Array</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  data() {
    return {
      datatransfer: [
        { key: "1", label: "Content 1", disabled: false },
        { key: "2", label: "Content 2", disabled: true },
        { key: "3", label: "Content 3", disabled: false }
      ],
      targetKeys: ["1", "2"]
    };
  },
  methods: {
    handleCHangeTranfer(newT) {
      console.log(newT);
    }
  }
};
</script>